import PocketedSpringPage from "../../components/pages/pocketedspringpage";

export default PocketedSpringPage;
